import { assert, log } from '../app/logger.js';
import { ChecklistEditor } from './checklist_editor.js';
import { UIQueueable } from '../ui/ui_queueable.js';
import { PendingFunction } from '../util/util.js';
import { window } from '../window.js';
import { ChecklistViewBase } from './checklist_view_base.js';

/**
 * Serves to get/set data from a checklist editor.
 */
class ChecklistViewEdit extends ChecklistViewBase {
  constructor() {
    super();

    this.pendingSave = new PendingFunction(
      UIQueueable(async () => {
        await this.#save();
        this.checklistChanged();
      }),
      1000
    );
    this.listEditor = new ChecklistEditor(this, () =>
      this.pendingSave.schedule()
    );
  }

  #save() {
    assert(this.checklist, `[checklist] save: no checklist is set`);
    log(`[checklist] save ${this.checklist && this.checklist.id} checklist`);
    return (
      this.pipe &&
      this.pipe.closure(() =>
        this.checklist.updateEditableItems(this.getDataFromUI())
      )
    );
  }

  // Protected
  pipeToData(refreshFunc) {
    this.pipe = this.checklist.pipeables.editableItems.pipe(refreshFunc);
  }

  setItem(itemEl, dataItem) {
    itemEl.textContent = dataItem.name;
  }

  static uiname = 'ChecklistViewEdit';
}

window.customElements.define('checklist-view-edit', ChecklistViewEdit);

export { ChecklistViewEdit };
